// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YVOmM","questions":"styles_questions__mszAs","footer":"styles_footer__2MyWq"};